import actions from "./actions";

const initState = {
  classroomAdmins: null,
  classroomAdmin: null,
  key: null,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_CLASSROOM_ADMIN_SUCCESS:
      return { ...state, classroomAdmins: action.classroomAdmins };
    case actions.FETCH_CLASSROOM_ADMIN_DETAILS_SUCCESS:
    case actions.EDIT_SINGLE_CLASSROOM_ADMIN_SUCCESS:
    case actions.DELETE_CLASSROOM_ADMIN_SUCCESS:
      return { ...state, classroomAdmin: action.classroomAdmin };
    case actions.SET_FILTER:
      return { ...state, key: action.key };
    case actions.RESET:
      return { ...state, classroomAdmins: null, classroomAdmin: null };
    default:
      return state;
  }
}
